import React from 'react';
import './Thread.css';
import ReplyForm from './ReplyForm';


const ThreadLast = (props) => {


  return (
    <div className="Person">
      <div>{props.threadItem._source.eventFrom}</div>
      <div>Sent: {new Date(props.threadItem._source.appTimestamp).toLocaleString()}</div>
      <div>To: {props.threadItem._source.eventTo}</div>
      {props.threadItem._source.eventCc ?
        <div>cc: {props.threadItem._source.eventCc}</div>
        : null
      }
      {props.threadItem._source.attachmentExists ? 
        <div align="right">attachment: {props.threadItem._source.attachmentExists.toString()}</div>
        : null
      }
      <div onClick={props.clicked} align="right" >Click to Reply</div>
      <p>Subject: <b>{props.threadItem._source.eventSubject}</b></p>
      <div dangerouslySetInnerHTML={{__html: props.threadItem._source.bodyPreview}} />
      {props.showEditReply ? 
        <ReplyForm
          threadItem={props.threadItem}
          clickedCancel={props.clicked}
        />
        : null
      }
    </div>
  );
}

export default ThreadLast;


// WEBPACK FOOTER //
// ./src/containers/Timeline/ThreadLast.js